import Joi from '@hapi/joi'

export const DailyCollectionCategoryObject = {
    groupID: Joi.number().invalid(0).required().label("Group Name").messages({
        "any.invalid": `Group Name cannot have invalid characters`,
        "any.required": `Group Name characters`
    }),
    routeID: Joi.number().invalid(0).required().label("Factory Type").messages({
        "any.invalid": `Route Name cannot have invalid characters`,
        "any.required": `Route Name characters`
    }),
    factoryID: Joi.number().invalid(0).required().label("Route Name").messages({
        "any.invalid": `Factory Name cannot have invalid characters`,
        "any.required": `Factory Name Type characters`
    }),
    searchdate: Joi.string().invalid("").label("Search Date"),
    toDate: Joi.string().invalid("").label("Search Date")
}